import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { invalidateDocumentCategoryCache, useSwitchForcePushStatus } from 'src/api/document-category'
import { toast } from 'react-toastify'
import { GenericDialogLayout } from 'src/components/GenericDialogLayout'
import { ShowDialogProps } from 'src/show-dialog'
import { Typography, Button } from '@mui/material'

interface SwitchForcePushStatusProps extends ShowDialogProps {
  id: EntityId
  isForcePushed: boolean
}

export const SwitchForcePushStatusDialog: React.FC<SwitchForcePushStatusProps> = ({ pop, id, isForcePushed }) => {
  const { t: translate } = useTranslation(['document-category', 'common', 'common-api-message'])
  const mutation = useSwitchForcePushStatus(id)

  const onSubmit = useCallback(async () => {
    await mutation.mutateAsync(
      { isForcePushed },
      {
        onSuccess: () => {
          toast.success(translate('successfullyUpdated', { ns: 'common-api-message' }))
          invalidateDocumentCategoryCache.useGetDocumentCategories()
          pop(true)
        },
        onError: () => {
          toast.error(translate('CannotUpdateDocumentCategory', { ns: 'document-category' }))
        },
      },
    )
  }, [mutation, translate, pop])

  return (
    <GenericDialogLayout
      title={translate(isForcePushed ? 'force-and-push-document-category' : 'undo-force-and-push-document-category', {
        ns: 'document-category',
      })}
      pop={pop}
    >
      <Typography sx={{ p: 1 }} variant="subtitle1">
        {translate(isForcePushed ? 'confirm-push' : 'confirm-undo', { ns: 'document-category' })}
      </Typography>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
        <Button variant="contained" color="primary" onClick={onSubmit} sx={{ textTransform: 'none' }}>
          {translate('yes', { ns: 'common' })}
        </Button>
      </div>
    </GenericDialogLayout>
  )
}
